module.exports = __webpack_public_path__ + "img/ic_user_error.d79836bd.svg";